import { StandaloneProseProps } from '@/components/element/Prose';
import { propClassName } from '@/styles/ContentHeading';
import { ClassNameProp, StandaloneComponent } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { standaloneComponent } from 'modules/dynamic-components';

const Prose = standaloneComponent<StandaloneProseProps>('ElementProse');

export interface HeadingProps extends Omit<StandaloneProseProps, 'markup'> {
  content?: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

const HeadingComponent: StandaloneComponent<HeadingProps> = ({
  content,
  tag = 'h2',
  colors,
  size,
  variant,
  options,
  ...props
}) => {
  const { className, ...baseProps } = options ?? {};

  const colorsClassName = propClassName('colors', colors);
  const sizeClassName = propClassName('size', size);
  const variantClassName = propClassName('variant', variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  const markup = `<${tag}>${content}</${tag}>`;

  return <Prose options={{ className: componentClassName }} {...{ markup }} {...baseProps} {...props} />;
};

export const Heading = HeadingComponent;
